import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreAlarmLogsReportWizard',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Object,
      required: false,
      default: null
    },
    smartGroupId: {
      type: Number,
      required: false,
      default: null
    },
    accountId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      formValid: false,
      reportModel: {
        tenantId: null,
        smartGroupId: null,
        meta: {
          title: '',
          description: ''
        },
        filters: {
          originType: 'virtual-device--health-state',
          operationalStatus: null,
          categories: [],
          severities: [],
          condition: null
        },
        timeTrigger: {
          timeZone: 'Europe/Berlin'
        },
        actions: [{
          params: {
            subject: 'Alarmreport {{alarmReportName}} for {{smartGroupName}}',
            locale: 'en-US'
          },
          tables: ['all']
        }]
      },
      step: 1
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })),
  watch: {
    editItem: {
      handler: function handler(val) {
        if (val) {
          this.updateReportModel(val);
        }
      },
      immediate: true
    },
    smartGroupId: {
      handler: function handler(val) {
        if (val) {
          this.reportModel.smartGroupId = val;
        }
      },
      immediate: true
    },
    accountId: {
      handler: function handler(val) {
        if (val) {
          this.reportModel.tenantId = val;
        }
      },
      immediate: true
    }
  },
  created: function created() {},
  methods: {
    closeDialog: function closeDialog() {
      this.step = 1;
      this.reportModel.tenantId = null;
      this.reportModel.meta.title = '';
      this.$emit('close');
    },
    updateReportModel: function updateReportModel(e) {
      this.reportModel = cloneDeep(e);

      if (this.smartGroupId) {
        this.reportModel.smartGroupId = this.smartGroupId;
      }

      if (this.accountId) {
        this.reportModel.tenantId = this.accountId;
      }
    },
    submitReport: function submitReport() {
      var _this = this;

      var promise = !!this.reportModel.id ? ApiService.updateAlarmReport(this, this.reportModel) : ApiService.createAlarmReport(this, this.reportModel);
      promise.then(function () {
        _this.$emit('submitted');

        return null;
      }).catch(function () {
        _this.$snack(_this.$t('AlarmLogs.snacks.reportSubmitFailed'), 'error');
      });
    }
  }
};